import { BalancePaymentUrl } from "../directives/utilities/urls";
export default function myAccountWelcome() {
    return {
       
        message:'',
        showLoader: false,
        categoryId: "",
        allowRegistration:true,
       
        payBalancePayment() {
            fetch("/api/basket/AddBalancePaymentToCart", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {                    
                    if (response.isSuccess) {
                        document.location.href = BalancePaymentUrl;
                    } else {
                        this.message = 'Unable to process request please try later.';
                    }
                });

        },

        OnImpersonateStudentClick() {
            window.location.href = "/impersonate-login";

        },
        
        init() {
           
        },
    };
}
